import LeftBackgroundSvg from '@assets/confirmation_screen/left.svg'
import RightBackgroundSvg from '@assets/confirmation_screen/right.svg'
import ImageLogo from '@assets/logo.svg'
import { ChangePasswordForm } from '@components/organisms/ChangePasswordForm'
import { useParams } from 'react-router-dom'
import * as S from './ResetPassword.styles'

export interface SignupProps {
  testId?: string
}

export const ResetPassword = ({
  testId = 'component-checkemail-id'
}: SignupProps) => {
  const { passwordToken } = useParams()

  return (
    <S.Container data-testid={testId}>
      <S.GradientBackground>
        <S.LogoWrapper>
          <S.LogoArea>
            <S.Logo src={ImageLogo} alt="Jombine's logo" />
          </S.LogoArea>
        </S.LogoWrapper>

        <S.LeftBackground
          src={LeftBackgroundSvg}
          alt="Background image with an arrow pointing downwards with an o"
        />
        <S.RightBackground
          src={RightBackgroundSvg}
          alt="Background image with an arrow pointing upwards with an x"
        />

        <S.RoundedBox>
          <ChangePasswordForm passwordToken={passwordToken} />
        </S.RoundedBox>
      </S.GradientBackground>
    </S.Container>
  )
}
